var locale = [{
  path: "appIndexJsZH",
  name: "zh-CN",
  label: "简体中文"
}, {
  path: "appIndexJsEN",
  name: "en-US",
  label: "English"
}, {
  path: "appIndexJsZH",
  name: "zh-TW",
  label: "繁體中文"
}];
export default locale;